module.exports = __webpack_public_path__ + "static/media/join-event.1f7ac8b4.svg";